import _toConsumableArray from "D:/VUE\u5EB7\u4E50\u901A\u603B\u540E\u53F0/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withKeys as _withKeys, normalizeClass as _normalizeClass, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, renderSlot as _renderSlot } from "vue";
var _hoisted_1 = {
  key: 0,
  "class": "transfer-header transfer-h5-header"
};
var _hoisted_2 = {
  "class": "title"
};
var _hoisted_3 = {
  "class": "main"
};
var _hoisted_4 = {
  "class": "left"
};
var _hoisted_5 = {
  "class": "transfer-header"
};
var _hoisted_6 = ["value", "placeholder"];
var _hoisted_7 = ["placeholder", "value"];
var _hoisted_8 = {
  "class": "transfer-left-main"
};
var _hoisted_9 = {
  "class": "transfer-list"
};
var _hoisted_10 = {
  key: 1,
  "class": "icon-unselected"
};
var _hoisted_11 = {
  "class": "select-all"
};
var _hoisted_12 = ["onClick"];
var _hoisted_13 = ["src"];
var _hoisted_14 = {
  "class": "name"
};
var _hoisted_15 = {
  key: 0
};
var _hoisted_16 = {
  "class": "right"
};
var _hoisted_17 = {
  key: 0,
  "class": "transfer-header"
};
var _hoisted_18 = {
  key: 1,
  "class": "transfer-list"
};
var _hoisted_19 = {
  key: 0,
  "class": "transfer-text"
};
var _hoisted_20 = {
  "class": "transfer-list-item-content"
};
var _hoisted_21 = ["src"];
var _hoisted_22 = {
  key: 0,
  "class": "name"
};
var _hoisted_23 = ["onClick"];
var _hoisted_24 = {
  "class": "transfer-right-footer"
};
import { ref, watchEffect, computed } from "../../../adapter-vue";
import { TUITranslateService } from "@tencentcloud/chat-uikit-engine";
import Icon from "../Icon.vue";
import selectedIcon from "../../../assets/icon/selected.svg";
import backIcon from "../../../assets/icon/back.svg";
import cancelIcon from "../../../assets/icon/cancel.svg";
import { isPC, isWeChat, isUniFrameWork } from "../../../utils/env";
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    list: {
      type: Array,
      "default": function _default() {
        return [];
      }
    },
    selectedList: {
      type: Array,
      "default": function _default() {
        return [];
      }
    },
    isSearch: {
      type: Boolean,
      "default": true
    },
    isRadio: {
      type: Boolean,
      "default": false
    },
    isCustomItem: {
      type: Boolean,
      "default": false
    },
    title: {
      type: String,
      "default": ""
    },
    type: {
      type: String,
      "default": ""
    },
    resultShow: {
      type: Boolean,
      "default": true
    },
    total: {
      type: Number,
      "default": 0
    },
    isHiddenBackIcon: {
      type: Boolean,
      "default": false
    }
  },
  emits: ["search", "submit", "cancel", 'getMore'],
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    var props = __props;
    var type = ref("");
    var transferList = ref([]);
    var transferTotal = ref(0);
    var transferSelectedList = ref([]);
    var isTransferSearch = ref(true);
    var isTransferCustomItem = ref(false);
    var transferTitle = ref("");
    var searchValue = ref("");
    watchEffect(function () {
      if (props.isCustomItem) {
        for (var index = 0; index < props.list.length; index++) {
          if (props.list[index].conversationID.indexOf("@TIM#SYSTEM") > -1) {
            props.list.splice(index, 1);
          }
          transferList.value = props.list;
        }
      } else {
        transferList.value = props.list;
      }
      transferTotal.value = props.total ? props.total : props.list.length;
      transferSelectedList.value = props.selectedList && props.selectedList.length > 0 ? props.selectedList : transferSelectedList.value;
      isTransferSearch.value = props.isSearch;
      isTransferCustomItem.value = props.isCustomItem;
      transferTitle.value = props.title;
      type.value = props.type;
    });
    var emit = __emit;
    // 可选项
    var optional = computed(function () {
      return transferList.value.filter(function (item) {
        return !item.isDisabled;
      });
    });
    var handleInput = function handleInput(e) {
      searchValue.value = e.target.value;
      emit("search", e.target.value);
    };
    var selected = function selected(item) {
      if (item.isDisabled) {
        return;
      }
      var list = transferSelectedList.value;
      var index = list.indexOf(item);
      if (index > -1) {
        return transferSelectedList.value.splice(index, 1);
      }
      if (props.isRadio) {
        list = [];
      }
      list.push(item);
      transferSelectedList.value = list;
    };
    var selectedAll = function selectedAll() {
      if (transferSelectedList.value.length === optional.value.length) {
        transferSelectedList.value = [];
      } else {
        transferSelectedList.value = _toConsumableArray(optional.value);
      }
    };
    var submit = function submit() {
      emit("submit", transferSelectedList.value);
      // 针对小程序做的数据清空
      searchValue.value = "";
    };
    var cancel = function cancel() {
      emit("cancel");
      // 针对小程序做的数据清空
      searchValue.value = "";
    };
    var getMore = function getMore() {
      emit("getMore");
    };
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", {
        "class": _normalizeClass(["transfer", [!_unref(isPC) ? 'transfer-h5' : '', _unref(isWeChat) ? 'transfer-h5-wechat' : '']])
      }, [!_unref(isPC) ? (_openBlock(), _createElementBlock("header", _hoisted_1, [!props.isHiddenBackIcon ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        onClick: cancel
      }, [_createVNode(Icon, {
        "class": "icon",
        file: _unref(backIcon),
        width: '18px',
        height: '18px'
      }, null, 8, ["file"])])) : _createCommentVNode("", true), _createElementVNode("span", _hoisted_2, _toDisplayString(_unref(transferTitle)), 1), _cache[0] || (_cache[0] = _createElementVNode("span", {
        "class": "space"
      }, null, -1))])) : _createCommentVNode("", true), _createElementVNode("main", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("header", _hoisted_5, [_unref(isPC) && _unref(isTransferSearch) ? (_openBlock(), _createElementBlock("input", {
        key: 0,
        type: "text",
        value: _unref(searchValue),
        onKeyup: _withKeys(handleInput, ["enter"]),
        placeholder: _unref(TUITranslateService).t('component.请输入userID'),
        enterkeyhint: "search",
        "class": _normalizeClass([_unref(isUniFrameWork) ? 'left-uniapp-input' : ''])
      }, null, 42, _hoisted_6)) : _createCommentVNode("", true), !_unref(isPC) && _unref(isTransferSearch) ? (_openBlock(), _createElementBlock("input", {
        key: 1,
        type: "text",
        onBlur: handleInput,
        onConfirm: handleInput,
        placeholder: _unref(TUITranslateService).t('component.请输入userID'),
        enterkeyhint: "search",
        value: _unref(searchValue),
        "class": _normalizeClass([_unref(isUniFrameWork) ? 'left-uniapp-input' : ''])
      }, null, 42, _hoisted_7)) : _createCommentVNode("", true)]), _createElementVNode("main", _hoisted_8, [_createElementVNode("ul", _hoisted_9, [_unref(optional).length > 1 && !__props.isRadio ? (_openBlock(), _createElementBlock("li", {
        key: 0,
        "class": "transfer-list-item",
        onClick: selectedAll
      }, [_unref(transferSelectedList).length === _unref(optional).length ? (_openBlock(), _createBlock(Icon, {
        key: 0,
        file: _unref(selectedIcon),
        width: '18px',
        height: '18px'
      }, null, 8, ["file"])) : (_openBlock(), _createElementBlock("i", _hoisted_10)), _createElementVNode("span", _hoisted_11, _toDisplayString(_unref(TUITranslateService).t("component.全选")), 1)])) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(transferList), function (item, index) {
        return _openBlock(), _createElementBlock("li", {
          "class": "transfer-list-item",
          key: item.userID,
          onClick: function onClick($event) {
            return selected(item);
          }
        }, [_unref(transferSelectedList).indexOf(item) > -1 ? (_openBlock(), _createBlock(Icon, {
          key: 0,
          file: _unref(selectedIcon),
          "class": _normalizeClass([item.isDisabled && 'disabled']),
          width: '18px',
          height: '18px'
        }, null, 8, ["file", "class"])) : (_openBlock(), _createElementBlock("i", {
          key: 1,
          "class": _normalizeClass([item.isDisabled && 'disabled', 'icon-unselected'])
        }, null, 2)), !_unref(isTransferCustomItem) ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 2
        }, [_createElementVNode("img", {
          "class": "avatar",
          src: item.avatar || 'https://web.sdk.qcloud.com/component/TUIKit/assets/avatar_21.png',
          onerror: "this.onerror=null;this.src='https://web.sdk.qcloud.com/component/TUIKit/assets/avatar_21.png'"
        }, null, 8, _hoisted_13), _createElementVNode("span", _hoisted_14, _toDisplayString(item.nick || item.userID), 1), item.isDisabled ? (_openBlock(), _createElementBlock("span", _hoisted_15, "（" + _toDisplayString(_unref(TUITranslateService).t("component.已在群中")) + "）", 1)) : _createCommentVNode("", true)], 64)) : _renderSlot(_ctx.$slots, "left", {
          key: 3,
          data: item
        })], 8, _hoisted_12);
      }), 128)), _unref(transferTotal) > _unref(transferList).length ? (_openBlock(), _createElementBlock("li", {
        key: 1,
        "class": "transfer-list-item more",
        onClick: getMore
      }, _toDisplayString(_unref(TUITranslateService).t("component.查看更多")), 1)) : _createCommentVNode("", true)])])]), _createElementVNode("div", _hoisted_16, [_unref(isPC) ? (_openBlock(), _createElementBlock("header", _hoisted_17, _toDisplayString(_unref(transferTitle)), 1)) : _createCommentVNode("", true), __props.resultShow ? (_openBlock(), _createElementBlock("ul", _hoisted_18, [_unref(transferSelectedList).length > 0 && _unref(isPC) ? (_openBlock(), _createElementBlock("p", _hoisted_19, _toDisplayString(_unref(TUITranslateService).t("component.已选中")) + _toDisplayString(_unref(transferSelectedList).length) + _toDisplayString(_unref(TUITranslateService).t("component.人")), 1)) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(transferSelectedList), function (item, index) {
        return _openBlock(), _createElementBlock("li", {
          "class": "transfer-list-item space-between",
          key: index
        }, [_createElementVNode("aside", _hoisted_20, [!_unref(isTransferCustomItem) ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 0
        }, [_createElementVNode("img", {
          "class": "avatar",
          src: item.avatar || 'https://web.sdk.qcloud.com/component/TUIKit/assets/avatar_21.png',
          onerror: "this.onerror=null;this.src='https://web.sdk.qcloud.com/component/TUIKit/assets/avatar_21.png'"
        }, null, 8, _hoisted_21), _unref(isPC) ? (_openBlock(), _createElementBlock("span", _hoisted_22, _toDisplayString(item.nick || item.userID), 1)) : _createCommentVNode("", true)], 64)) : _renderSlot(_ctx.$slots, "right", {
          key: 1,
          data: item
        })]), _unref(isPC) ? (_openBlock(), _createElementBlock("span", {
          key: 0,
          onClick: function onClick($event) {
            return selected(item);
          }
        }, [_createVNode(Icon, {
          file: _unref(cancelIcon),
          width: '18px',
          height: '18px'
        }, null, 8, ["file"])], 8, _hoisted_23)) : _createCommentVNode("", true)]);
      }), 128))])) : _createCommentVNode("", true), _createElementVNode("footer", _hoisted_24, [_createElementVNode("button", {
        "class": "btn btn-cancel",
        onClick: cancel
      }, _toDisplayString(_unref(TUITranslateService).t("component.取消")), 1), _unref(transferSelectedList).length > 0 ? (_openBlock(), _createElementBlock("button", {
        key: 0,
        "class": "btn",
        onClick: submit
      }, _toDisplayString(_unref(TUITranslateService).t("component.完成")), 1)) : (_openBlock(), _createElementBlock("button", {
        key: 1,
        "class": "btn btn-no",
        onClick: submit
      }, _toDisplayString(_unref(TUITranslateService).t("component.完成")), 1))])])])], 2);
    };
  }
});